// Global error handler to suppress external errors (browser extensions, etc.)
// KeeperFix.js handles most of this, but this is a backup
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message?.toString() || '';
  const errorSource = event.reason?.stack?.toString() || '';
  const errorString = event.reason?.toString() || '';
  const combinedMessage = (errorMessage + ' ' + errorSource + ' ' + errorString).toLowerCase();
  
  const extensionPatterns = [
    'settingnametotoggle',
    'could not establish connection',
    'receiving end does not exist',
    'message channel closed',
    'moved into back/forward cache',
    'back/forward cache',
    'page keeping the extension port',
    'extension port',
    'a listener indicated an asynchronous response',
    'message channel closed before a response was received',
    'returning true, but the message channel closed',
    'bg.js',
    '6.js',
    'chrome-extension://',
    'moz-extension://',
    'safari-extension://',
    'runtime.lasterror',
    'runtime.lastError',
    'unchecked runtime.lasterror',
    'unchecked runtime.lastError',
    'extension context invalidated',
    'message port closed',
    'error in event handler',
    'cannot read properties of null',
    'reading \'dataset\''
  ];
  
  if (extensionPatterns.some(pattern => combinedMessage.includes(pattern))) {
    event.preventDefault();
    return;
  }
}, true);

window.addEventListener('error', (event) => {
  const errorMessage = event.error?.message?.toString() || '';
  const errorSource = event.error?.stack?.toString() || '';
  const errorFileName = event.filename || '';
  const combinedMessage = (errorMessage + ' ' + errorSource + ' ' + errorFileName).toLowerCase();
  
  const extensionPatterns = [
    'settingnametotoggle',
    'could not establish connection',
    'receiving end does not exist',
    'message channel closed',
    'moved into back/forward cache',
    'back/forward cache',
    'page keeping the extension port',
    'extension port',
    'a listener indicated an asynchronous response',
    'message channel closed before a response was received',
    'returning true, but the message channel closed',
    'bg.js',
    '6.js',
    'chrome-extension://',
    'moz-extension://',
    'safari-extension://',
    'runtime.lasterror',
    'runtime.lastError',
    'unchecked runtime.lasterror',
    'unchecked runtime.lastError',
    'extension context invalidated',
    'message port closed',
    'error in event handler',
    'cannot read properties of null',
    'reading \'dataset\''
  ];
  
  if (extensionPatterns.some(pattern => combinedMessage.includes(pattern))) {
    event.preventDefault();
    return;
  }
}, true);